import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "@/assets/css/reset.css"
import "@/assets/font/iconfont.css"

Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


Vue.use(ElementUI);

Vue.prototype.$bus = new Vue();

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
